import * as Profile from 'app/entities/Profile';
import ActionTypes from 'app/shared-zap/ActionTypes';
import Data from 'app/shared-zap/Data';
import { NEW_ZAP_ID } from 'app/beta-editor/constants';
import { isSharedZapLoaded } from 'app/shared-zap/Selectors';
import { toFlow } from 'app/shared-zap/SharedZapUtils';

const Actions = {
  loadSharedZap(id, { shouldSuppress404Errors = false } = {}) {
    return (dispatch, getState) => {
      const sharedZapLoaded = isSharedZapLoaded(id)(getState());
      const currentUserId = Profile.selectors.all.currentProfileId(getState());

      if (currentUserId && !sharedZapLoaded) {
        return dispatch({
          type: ActionTypes.LOAD_SHARED_ZAP,
          promise: Data.sharedZap(id),
          formatError(error) {
            if (error.status === 404 && shouldSuppress404Errors) {
              return {};
            }

            return { error };
          },
        });
      }

      return Promise.resolve(undefined);
    };
  },

  addSharedZapFlow(id) {
    return (dispatch, getState) => {
      const sharedZap = getState().sharedZap.sharedZaps[id];
      const flow = {
        ...toFlow(sharedZap, NEW_ZAP_ID),
        isLoading: false,
        isLoaded: true,
        progress: [1, 1],
      };
      return dispatch({
        type: ActionTypes.ADD_SHARED_ZAP_FLOW,
        id,
        flow,
      });
    };
  },
};

export default Actions;
